"use client";

import Link from "next/link";
import { useState } from "react";
import {
  LuDollarSign,
  LuEllipsis as LuMoreHorizontal,
  LuExternalLink,
  LuUser,
} from "react-icons/lu";

import { Button } from "@/components/ui/button";
import {
  DropdownDrawer,
  DropdownDrawerContent,
  DropdownDrawerItem,
  DropdownDrawerTrigger,
} from "@/components/ui/dropdown-drawer";
import { APP_ROUTES } from "@/utils/constants";
interface TopTradersActionsProps {
  publicKey: string;
  username: string;
}

const TopTradersActions = ({ publicKey, username }: TopTradersActionsProps) => {
  const [open, setOpen] = useState(false);
  return (
    <DropdownDrawer
      historyName="top-trader-actions"
      open={open}
      onOpenChange={setOpen}
      title="Trader actions"
    >
      <DropdownDrawerTrigger
        render={
          <Button
            variant="outline"
            size="icon"
            className="
              size-full rounded-full border-none text-sm
              hover:bg-transparent
            "
          >
            <LuMoreHorizontal className="size-4" />
          </Button>
        }
      />
      <DropdownDrawerContent sideOffset={-8}>
        <DropdownDrawerItem
          className="text-inherit"
          render={
            <Link
              href={`${APP_ROUTES.tradePortfolio}/${username || publicKey}`}
              className="flex items-center gap-2"
            >
              <LuDollarSign className="size-4 text-muted" />
              View Trading Activity
            </Link>
          }
        />
        <DropdownDrawerItem
          className="text-inherit"
          render={
            <Link
              href={`${APP_ROUTES.app}${publicKey}`}
              className="flex items-center gap-2"
            >
              <LuUser className="size-4 text-muted" />
              View Profile
            </Link>
          }
        />
        <DropdownDrawerItem
          className="text-inherit"
          render={
            <Link
              href={`${process.env.NEXT_PUBLIC_EXPLORER_URI}/u/${publicKey}`}
              className="flex items-center gap-2"
              target="_blank"
            >
              <LuExternalLink className="size-4 text-muted" />
              Block Explorer
            </Link>
          }
        />
      </DropdownDrawerContent>
    </DropdownDrawer>
  );
};

export default TopTradersActions;
